import { format } from "date-fns";

function formatDate(date: Date, formatStr: string) {
	return format(date, formatStr);
}

const dateUtils = {
	format: formatDate,
};

export { dateUtils };
